export const formatPresetsToList = (presets) => {
  return presets.map((item) => {
    return {
      label: item.preset.name,
      value: item.id,
    };
  });
};
